import React from 'react';
import Remarks from '././remarks';

function RemarksMain() {
  return (
    <div className="main-content-bottom">
        <Remarks/>
    </div>
  );
}

export default RemarksMain;
